export default {
    scheme: 'solar flare',
    author: 'Chuck Harmston (https://chuck.harmston.ch)',
    base00: '#18262F',
    base01: '#222E38',
    base02: '#586875',
    base03: '#667581',
    base04: '#85939E',
    base05: '#A6AFB8',
    base06: '#E8E9ED',
    base07: '#F5F7FA',
    base08: '#EF5253',
    base09: '#E66B2B',
    base0A: '#E4B51C',
    base0B: '#7CC844',
    base0C: '#52CBB0',
    base0D: '#33B5E1',
    base0E: '#A363D5',
    base0F: '#D73C9A',
};
